
import React, { useState } from 'react';
import { IoIosArrowForward } from "react-icons/io";
import { Link,useNavigate } from 'react-router-dom';
import './Contact.css'
import ReactGA from 'react-ga'; // Import ReactGA if you're using it for Google Analytics tracking

const Contact = () => {
    const [status, setStatus] = useState("Submit");
    const navigate = useNavigate();
  const [info, setInfo] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    
    // Perform validations
    if (name === 'name') {
      // Allow only alphabets and spaces
      newValue = value.replace(/[^a-zA-Z\s]/g, '');
    } else if (name === 'phone') {
      // Allow only digits and limit to 10 characters
      newValue = value.replace(/\D/g, '').slice(0, 10);
    }

    setInfo({
      ...info,
      [name]: newValue,
    });
  };

  const handleSubmit = async (e) => {
        e.preventDefault();
        ReactGA.event({
            category : "contact us",
            action: "Submit button click",
            value : 1,
        });

        try {
            let response = await fetch(`/api/contact`, {
              method: "POST",
              headers: {
                "Access-Control-Allow-Origin": "*",
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8",
              },
              body: JSON.stringify(info),
            });
            setStatus("Submitted");
            setInfo({ name: "", email: "", phone: "", subject: "", message: "" });
            let result = await response.json();
            console.log(result);
      
            // Navigate to ThankYou page
            navigate("/ThankYou");
          } catch (error) {
            console.error("Error submitting form:", error);
          }
        };


  return (
    <div>

<div className='bg_banner_contact ' >
         <h1 >Contact Us</h1>
         <div className='bread_craum'>
            <Link to="/" style={{textDecoration:"auto",fontFamily:"Nunito",color:"#0F172B"}}>Home</Link>
             <IoIosArrowForward style={{color:"#0F172B",marginTop:"4px"}}/>
            <Link to="" style={{textDecoration:"auto",fontFamily:"Nunito",color:"#0F172B"}}>Contact</Link>
         </div>
    </div>
    
    <section className="contact-page-section">
      <div className="container">
          <div className="sec-title">
              <div className="title">Contact Us</div>
                <h2>Let's Get in Touch.</h2>
            </div>
            <div className="inner-container">
              <div className="row clearfix">
                
                 
                    <div className="form-column col-md-8 col-sm-12 col-xs-12">
                      <div className="inner-column">
                          
                            
                            <div className="contact-form">
                                <form method="post"  id="contact-form">
                                    <div className="row clearfix">
                                        <div className="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input type="text"
                                             name="name" 
                                             id="name"
                                             value={info.name}
                                             onChange={handleChange}
                                             placeholder="Name"
                                              required/>
                                        </div>
                                        <div className="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input type="email" 
                                            name="email"
                                           value={info.email}
                                             onChange={handleChange}
                                             placeholder="Email" required/>
                                        </div>
                                        <div className="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input type="text"
                                             name="subject"
                                             value={info.subject}
                                             onChange={handleChange}
                                              placeholder="Subject" required/>
                                        </div>
                                        <div className="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input type="text"
                                             name="phone" 
                                             value={info.phone}
                                             onChange={handleChange}
                                             placeholder="Phone" required/>
                                        </div>
                                        <div className="form-group col-md-12 col-sm-12 co-xs-12">
                                            <textarea name="message"
                                            value={info.message}
                                            onChange={handleChange}
                                             placeholder="Message"></textarea>
                                        </div>
                                        <div className="form-group col-md-12 col-sm-12 co-xs-12">
                                            <button type="submit" className="theme-btn" style={{color:"#b8b4b4"}} onClick={handleSubmit }>Send Now</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                           
                            
                        </div>
                    </div>
                    
                  
                    <div className="info-column col-md-4 col-sm-12 col-xs-12">
                      <div className="inner-column">
                    
                          <h2>Contact Info</h2>
                            <ul className="list-info">
                              <li><i className="fas fa-globe"></i>
                              No.91/2, Garudacharpalya, Behind Brigade Metropolis, Mahadevapura post, Bengaluru-560048.
                              </li>
                                <li><i className="far fa-envelope"></i>gifcoautofilters@gmail.com</li>
                                <li><i className="fas fa-phone"></i>+91 9980411999<br/>+91 ⁠9845164986<br/>+91 7892882698</li>
                              
                            </ul>
                          
                            {/* <ul className="social-icon-four">
                                <li className="follow">Follow on: </li>
                                <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i className="fab fa-google-plus-g"></i></a></li>
                                <li><a href="#"><i className="fab fa-dribbble"></i></a></li>
                                <li><a href="#"><i className="fab fa-pinterest-p"></i></a></li>
                            </ul> */}
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>
      
    </div>
  )
};
export default Contact;